<template>
    <div>
        
        <table class="table">
            <thead>
                <tr>
                    <th rowspan="2">No PO</th>
                    <th rowspan="2">Label Maker</th>
                    <th rowspan="2">PO Date</th>
                    <th rowspan="2">Variant</th>
                    <th colspan="5" class="text-center">Total Label Maker</th>
                </tr>
                <tr>
                    <!-- <th>No PO</th>
                    <th>Label Maker</th>
                    <th>PO Date</th>
                    <th>Variant</th> -->
                    <th>QR</th>
                    <th>Spare</th>
                    <th>Scan</th>
                    <!-- <th>Success</th> -->
                    <th>Activate</th>
                    <th>Failed</th>
                    <!-- <th>Deactive</th> -->
                </tr>
            </thead>
            <tbody class="detailStockTable">
                <template v-for="dat in data" v-if="data.length > 0">
                    <tr v-for="(da, i) in dat.content" :class="{'border-top' : i == 0}">
                        <td>{{ i==0 ? dat.no_po ? dat.no_po : '-' : '' }}</td>
                        <td>{{ i==0 ? dat.label_maker ? dat.label_maker : '-' : '' }}</td>
                        <td>{{ i==0 ? dat.po_date ? moment(dat.po_date).format('DD MMM YYYY HH:mm:ss') : '-' : '' }}</td>
                        <td>{{ da.variant ? da.variant : '0' }}</td>
                        <td>{{ da.qr_total ? numberWithCommas(da.qr_total) : '0' }}</td>
                        <td>{{ da.spare_total ? numberWithCommas(da.spare_total) : '0' }}</td>
                        <td>{{ da.scan_total ? numberWithCommas(da.scan_total) : '0' }}</td>
                        <!-- <td>{{ da.success ? numberWithCommas(da.success) : '0' }}</td> -->
                        <td>{{ da.activate ? numberWithCommas(da.activate) : '0' }}</td>
                        <td>{{ da.failed ? numberWithCommas(da.failed) : '0' }}</td>
                        <!-- <td>{{ da.deactive ? numberWithCommas(da.deactive) : '0' }}</td> -->
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="100%">
                        <p class="text-center pt-5 pb-5">No Data</p>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data () {
            return {
                moment : moment,
                dummyData : null,
            }
        },
        props : ['data'],
        mounted () {
            // this.generateDummyData();
        },
        methods : {
            generateDummyData () {
                let dummy = [];
                let date = moment();
                let labelMakers = this.$store.getters.getLabelMaker;
                let variants = this.$store.getters.getVariant;

                let names = ['Beat', 'Scoopy', 'Beatstreet', 'ADV 150', 'Genio', 'ADV', 'CBR', 'Genio']
                for (var i = 0; i < 20; i++) {
                    let singleDummy = {
                        no_po : `XVI - ${2495-i}`,
                        label_maker : labelMakers[this.randomInt(0, 1000) % labelMakers.length],
                        po_date : date.subtract(this.randomInt(2, 10), 'days').format("YYYY-MM-DD HH:mm:ss"),
                        content : []
                    }

                    variants = this.shuffle(variants);
                    for (var j = 0; j < this.randomInt(2, variants.length); j++) {
                        let success = this.randomInt(100, 1000);
                        let failed = this.randomInt(100, 300);
                        let activate = this.randomInt(100, 1000);
                        let deactive = this.randomInt(100, 200);

                        singleDummy.content.push({
                            variant : variants[this.randomInt(0, 1000) % variants.length],
                            qr_total : success + failed + deactive + this.randomInt(200, 1000),
                            spare_total : this.randomInt(100, 200),
                            scan_total : success + failed + deactive + activate,
                            success : success,
                            failed : failed,
                            activate : activate,
                            deactive : deactive,
                        })
                    }

                    dummy.push(singleDummy);
                }

                this.dummyData = dummy;
            },
            shuffle(array) {
                let currentIndex = array.length,  randomIndex;

                // While there remain elements to shuffle...
                while (currentIndex != 0) {

                    // Pick a remaining element...
                    randomIndex = Math.floor(Math.random() * currentIndex);
                    currentIndex--;

                    // And swap it with the current element.
                    [array[currentIndex], array[randomIndex]] = [
                    array[randomIndex], array[currentIndex]];
                }

                return array;
            }
        }
    }
</script>

<style scoped>
    tbody {
        display: block;
        max-height: 65vh;
        overflow-y: scroll;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
        width: calc(100% - 10px);
    }

    thead tr th {
        border-bottom: 0.5px solid #FF0009;
        font: normal normal 500 14px/16px Ubuntu;
        color: #707070;
    }

    tbody tr td {
        font: normal normal 500 13px/14px Ubuntu;
        color: #707070;
        word-wrap: break-word;
    }

    thead tr th,
    tbody tr td {
        vertical-align: middle;
    }

    tbody tr td {
        border-top: 0;
    }

    tbody tr.border-top td:not(:first-child) {
        border-top: 1px solid #d6dadd;
    }

    .detailStockTable::-webkit-scrollbar{
        width:10px;
    }
    .detailStockTable::-webkit-scrollbar-track{
        background-color: white;
        border-radius: 20px;
    }
    .detailStockTable::-webkit-scrollbar-thumb{
        background-color: #F1F1F1;
        border-radius: 20px;
    }
</style>